import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthModalComponent } from "../shared-components/modals/auth-modal/auth-modal.component";
import { StudentLoginModalComponent } from "../shared-components/modals/student-login-modal/student-login-modal.component";
import { UserService } from "./user.service";
import * as i0 from "@angular/core";
import * as i1 from "./user.service";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
var LMModalService = /** @class */ (function () {
    function LMModalService(userService, modalService) {
        this.userService = userService;
        this.modalService = modalService;
    }
    LMModalService.prototype.openLoginModal = function () {
        if (this.userService.hasStudentExperience()) {
            this.modalService.open(StudentLoginModalComponent);
        }
        else {
            this.modalService.open(AuthModalComponent);
        }
    };
    LMModalService.ngInjectableDef = i0.defineInjectable({ factory: function LMModalService_Factory() { return new LMModalService(i0.inject(i1.UserService), i0.inject(i2.NgbModal)); }, token: LMModalService, providedIn: "root" });
    return LMModalService;
}());
export { LMModalService };
